import React from "react";
import { SOMETHING_WENT_WRONG } from "../../actions/actionTypes";
import { useDispatch } from "react-redux";
import { useFileRemoval } from "../../helpers/useFileRemoval";
import ErrorPopup from "./ErrorPopup";

const SomethingWentWrong = ({
  allFiles,
  setAllFiles,
  allProcessedFiles,
  setAllProcessedFiles
}) => {
  const dispatch = useDispatch();

  const { handleDelete, redirectToUpload } = useFileRemoval({
    allFiles,
    setAllFiles,
    allProcessedFiles,
    setAllProcessedFiles,
  });

  const onTryAgain = () => {
    dispatch({ type: SOMETHING_WENT_WRONG, payload: false });
    handleDelete();
    redirectToUpload();
  };

  return (
    <ErrorPopup variant="mid-popup" iconWidth="45" iconHeight="45" onTryAgain={onTryAgain}>
      <div className="upload-title-text">
        Sorry!
      </div>
      <div className="upload-content-text">
        There was a technical error.
      </div>
    </ErrorPopup>
  );
};

export default SomethingWentWrong;
